import { useDispatch, useSelector } from "react-redux";

import { CONTACTS_SEARCH_TABLE_PAGE_SIZE } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";
import { tableFiltersChangedAction } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/action-creators";
import { selectTableFilters } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { ContactsSearchTableFilters } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

const useContactsPagination = () => {
    const dispatch = useDispatch();
    const { page, pageSize }: ContactsSearchTableFilters = useSelector(selectTableFilters);

    const handlePageChange = (page: number, pageSize: number = CONTACTS_SEARCH_TABLE_PAGE_SIZE) => {
        dispatch(tableFiltersChangedAction({ page, pageSize }));
    };

    return {
        page,
        pageSize,
        handlePageChange,
    };
};

export default useContactsPagination;
